module.exports = __webpack_public_path__ + "static/media/send.2feee600.svg";